import { getObjectPool } from '../object-pool/object-pool.atom';

export const prepareDbgPoolDef = () => ({
  dump: getObjectPool,
});
